<template>
  <div class="page-container">
    <div class="header">
      <div class="left-side">
        <h4>Lista reklam</h4>
        <div>
          <b-button size="sm btn-success" @click="addBanner">
            <font-awesome-icon icon="plus" />
            Nowa
          </b-button>
        </div>
      </div>
      <div v-if="bannersTable.items.length > 1">
        <b-button v-if="!editOrderEnabled" size="sm" class="btn-warning" @click="editOrder">
          <font-awesome-icon icon="pen" />
          Edytuj kolejność
        </b-button>
        <div class="order-edit-buttons" v-else>
          <b-button size="sm" class="btn-info" @click="saveNewOrder">
            <font-awesome-icon icon="check" />
            Zapisz nową kolejności
          </b-button>
          <b-button size="sm" class="btn-danger" @click="cancelEditOrder">
            <font-awesome-icon icon="times" />
            Anuluj
          </b-button>
        </div>
      </div>
    </div>
    <div v-if="bannersTable.items.length === 0 && !firstLoadDone" class="mt-3">
      <b-alert show variant="info">
        Brak reklam, dodaj nową
      </b-alert>
    </div>
    <div v-if="bannersTable.items.length > 0">
      <b-table-simple class="table-item">
        <b-thead>
          <b-th v-if="editOrderEnabled"></b-th>
          <b-th v-for="field in bannersTable.fields" :key="field.key">
            {{ field.label }}
          </b-th>
        </b-thead>

        <draggable
          :disabled="!editOrderEnabled"
          :class="{ [`cursor-grabbing`]: drag === true }"
          v-model="bannersTable.items"
          handle=".handle"
          group="items"
          @start="drag = true"
          @end="drag = false"
          tag="tbody"
        >
          <b-tr v-for="item in bannersTable.items" :key="item.id" class="item-row">
            <b-td v-if="editOrderEnabled" class="handle">
              <div class="handle-icon">
                <font-awesome-icon style="height: 25px;" icon="grip-vertical" />
              </div>
            </b-td>
            <b-td>
              <img
                :src="item.image_url"
                alt="zdjęcie"
                @click="show(item.image_url)"
                class="zoom-cursor"
                style="height: 50px;"
              />
            </b-td>
            <b-td>{{ item.name }}</b-td>
            <b-td>
              <span v-if="item.enabled" class="text-success">Włączona</span>
              <span v-else class="text-danger">Wyłączona</span>
            </b-td>
            <b-td>{{ item.duration | formatDuration }}</b-td>
            <b-td>{{ item.updated_at | formatDate }}</b-td>
            <b-td>
              <b-button-group>
                <b-button class="btn-primary mr-1" size="sm" @click="editBanner(item)"
                  >Edycja</b-button
                >
                <b-button
                  :class="item.enabled ? 'btn-warning mr-1' : 'btn-success mr-1'"
                  size="sm"
                  @click="toggleBanner(item)"
                >
                  <span v-if="item.enabled">Wyłącz</span>
                  <span v-else>Włącz</span>
                </b-button>
                <b-button class="btn-danger" size="sm" @click="deleteBanner(item)">Usuń</b-button>
              </b-button-group>
            </b-td>
          </b-tr>
        </draggable>
      </b-table-simple>
      <vue-easy-lightbox
        :visible="visible"
        :imgs="imgs"
        :index="index"
        @hide="handleHide"
        :scrollDisabled="true"
      ></vue-easy-lightbox>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment'
import draggable from 'vuedraggable'
import VueEasyLightbox from 'vue-easy-lightbox'

export default {
  name: 'All-Banners',
  components: {
    draggable,
    VueEasyLightbox
  },
  async mounted() {
    const vm = this
    vm.$store.commit('addPageLoaderEvent', 'getAllBanners')
    moment.locale('pl')
    await vm.fetchBannersList()
    vm.$store.commit('removePageLoaderEvent', 'getAllBanners')
    vm.firstLoadDone = true
  },
  filters: {
    formatDate(value) {
      if (!value) return '---'
      return moment(value).format('YYYY-MM-DD HH:mm:ss')
    },
    formatDuration(value) {
      if (!value) return '---'
      const duration = moment.duration(value, 'seconds')
      return `${duration.hours() > 0 ? `${duration.hours()}h ` : ''}${
        duration.minutes() > 0 ? `${duration.minutes()}m ` : ''
      }${duration.seconds()}s`
    }
  },
  data() {
    return {
      firstLoadDone: false,
      drag: false,
      editOrderEnabled: false,
      previousItemsOrder: [],
      imgs: '',
      visible: false,
      index: 0,
      bannersTable: {
        sortBy: 'order',
        sortDesc: false,
        fields: [
          { key: 'image_url', label: '' },
          { key: 'name', label: 'Nazwa' },
          { key: 'enabled', label: 'Status' },
          { key: 'duration', label: 'Czas trwania' },
          { key: 'updated_at', label: 'Data ostatniej edycji' },
          { key: 'actions', label: 'Akcje' }
        ],
        items: []
      }
    }
  },
  computed: {
    isSuperAdmin() {
      return this.$store.state.userInfo.account_type === 'super_admin'
    }
  },
  methods: {
    show(imgURL) {
      this.imgs = imgURL
      this.visible = true
    },
    handleHide() {
      this.visible = false
    },
    editOrder() {
      this.previousItemsOrder = this.bannersTable.items
      this.editOrderEnabled = !this.editOrderEnabled
    },
    cancelEditOrder() {
      this.bannersTable.items = this.previousItemsOrder
      this.editOrderEnabled = !this.editOrderEnabled
    },
    async saveNewOrder() {
      const vm = this

      // check if order has changed
      if (JSON.stringify(vm.bannersTable.items) === JSON.stringify(vm.previousItemsOrder)) {
        vm.editOrderEnabled = !vm.editOrderEnabled
        return
      }

      try {
        const newOrder = vm.bannersTable.items.map((item, index) => ({
          id: item.id,
          order: index + 1
        }))

        console.log('New order', newOrder)

        vm.$store.commit('addPageLoaderEvent', 'saveNewOrder')

        await vm.$http.post('e-zacma/banners/change-orders', { banners: newOrder })

        await vm.fetchBannersList()

        vm.editOrderEnabled = !vm.editOrderEnabled
      } catch (e) {
        vm.$error()
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'saveNewOrder')
      }
    },
    async fetchBannersList() {
      const vm = this

      vm.$store.commit('addPageLoaderEvent', 'fetchBannersList')

      vm.$http
        .post('e-zacma/banners/list')
        .then(response => {
          vm.bannersTable.items = response.data.sort((a, b) => a.order - b.order)
        })
        .catch(e => vm.$error())
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'fetchBannersList')
        })
    },
    editBanner(item) {
      this.$router.push({ name: 'e-zacma-tablets-banners-edit', params: { id: item.id } })
    },
    async toggleBanner(row) {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'toggleBanner')

      try {
        await vm.$http.post('e-zacma/banners/toggle-status', { id: row.id })
        await vm.fetchBannersList()
      } catch (e) {
        vm.$error()
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'toggleBanner')
      }
    },
    async deleteBanner(row) {
      const vm = this
      try {
        vm.$store.commit('addPageLoaderEvent', 'deleteBanner')

        await vm.$http.post('e-zacma/banners/delete', { id: row.id })
        await vm.fetchBannersList()
      } catch (e) {
        vm.$error()
      } finally {
        vm.$store.commit('removePageLoaderEvent', 'deleteBanner')
      }
    },
    addBanner() {
      this.$router.push({ name: 'e-zacma-tablets-banners-add' })
    }
  }
}
</script>

<style scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .left-side {
    h4 {
      margin: 0;
    }

    display: flex;
    align-items: center;
    gap: 5px;
  }
}

.zoom-cursor {
  cursor: zoom-in;
}

.table-item {
  margin: 0.5rem;

  tr {
    background-color: #fff;
  }
}

.handle {
  cursor: pointer;

  .handle-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 40px;
  }
}

.order-edit-buttons {
  display: flex;
  gap: 5px;
}

.items pre {
  color: #fff;
  width: 200px;
  margin: auto;
}
</style>
